import { RuleResult } from 'types/DeclarationP5'
import { removePrefix } from 'shared/ncts/common/classifier-util'

const C0806Validator = {
  validateBorderTransportMeansRequirement: ({
    security,
    borderModeOfTransport,
    additionalDeclarationType,
  }: {
    security: string
    borderModeOfTransport: string
    additionalDeclarationType: string
  }): RuleResult => {
    const mode = removePrefix(borderModeOfTransport, 'TRANSPORT_MODE_', 1)
    if (mode === '5') {
      return 'NOT_ALLOWED'
    }
    if ((security === '1' || security === '2' || security === '3') && additionalDeclarationType === 'A') {
      return 'REQUIRED'
    }
    return 'OPTIONAL'
  },
} as const

export default C0806Validator
